var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.reportData)?_c('q-page',{staticClass:"flex column"},[_c('PowerBIReportEmbedded',{attrs:{"reportId":_vm.reportData.reportId,"datasetId":_vm.reportData.datasetId,"groupId":_vm.reportData.groupId,"filterPaneEnabled":"false","navContentPaneEnabled":"false"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }